import { render, staticRenderFns } from "./MembersView.vue?vue&type=template&id=b11ed0d8&"
import script from "./MembersView.vue?vue&type=script&lang=js&"
export * from "./MembersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports